import { FileText, MessageSquare, Trophy } from "lucide-react";
import { FUNNEL_STEPS } from "@/data/slate";

const STEP_ICONS = [FileText, MessageSquare, Trophy];

const HowItWorks = () => (
    <section
        id="how-it-works"
        data-testid="how-it-works-section"
        className="border-b border-border bg-[#FAF9F6]"
    >
        <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
            <div className="grid gap-16 md:grid-cols-12">
                <div className="md:col-span-4">
                    <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                        How Slate works
                    </p>
                    <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.05] tracking-tight md:text-5xl">
                        One system.
                        <br />
                        Three stages.
                        <br />
                        <span className="italic">Your voice</span> on every page.
                    </h2>
                    <p className="mt-6 max-w-md text-muted-foreground">
                        We don&apos;t replace your judgment. We sharpen it — with the
                        preparation senior roles deserve and nobody has time to build alone.
                    </p>
                </div>

                <div className="md:col-span-8">
                    <div className="grid gap-px bg-border md:grid-cols-1">
                        {FUNNEL_STEPS.map((step, i) => {
                            const Icon = STEP_ICONS[i];
                            return (
                                <div
                                    key={step.n}
                                    data-testid={`funnel-step-${step.n}`}
                                    className="group bg-[#FAF9F6] p-8 transition-colors hover:bg-card md:p-10"
                                >
                                    <div className="flex items-start gap-8">
                                        <div className="flex shrink-0 flex-col items-start">
                                            <span className="font-serif text-3xl italic text-muted-foreground">
                                                {step.n}
                                            </span>
                                            <Icon size={20} strokeWidth={1.5} className="mt-3 text-foreground" />
                                        </div>
                                        <div>
                                            <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">
                                                {step.label}
                                            </p>
                                            <h3 className="mt-3 font-serif text-2xl font-medium tracking-tight md:text-3xl">
                                                {step.title}
                                            </h3>
                                            <p className="mt-3 max-w-xl text-muted-foreground">
                                                {step.body}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default HowItWorks;
